export const baseCarPrices = {
  'Nissan Micra': 30,
  'Toyota Yaris': 30,
  'Renault Logan': 30,
  'Toyota Corolla': 40,
  'Renault Sandero': 40,
  'Renault Duster': 50,
  'Hyundai Tucson': 60,
  'Toyota Rav4': 65,
  'Hyundai Creta': 55,
  'Toyota Fortuner': 70,
  'Toyota Prado': 75,
};

// მანქანების დინამიური ფასები: [0-6 დღე, 7+ დღე, 14+ დღე]
export const dynamicCarPrices = {
  'Nissan Micra': [30, 25, 22],
  'Toyota Yaris': [30, 25, 22],
  'Renault Logan': [30, 25, 22],
  'Toyota Corolla': [40, 35, 30],
  'Renault Sandero': [40, 35, 30],
  'Renault Duster': [50, 45, 40],
  'Hyundai Tucson': [60, 55, 50],
  'Toyota Rav4': [65, 60, 55],
  'Hyundai Creta': [55, 50, 45],
  'Toyota Fortuner': [70, 65, 60],
  'Toyota Prado': [75, 70, 65],
};

// ფუნქცია რომელიც ითვლის ფასს დღეების რაოდენობიდან გამომდინარე
export const calculatePrice = (carName, days) => {
  if (!dynamicCarPrices[carName] || days <= 0) return 0;

  const [basePrice, weekPrice, twoWeekPrice] = dynamicCarPrices[carName];
  
  if (days >= 14) {
    return twoWeekPrice;
  } else if (days >= 7) {
    return weekPrice;
  } else {
    return basePrice;
  }
};